import BaseSkeleton from 'components/Generic/BaseSkeleton';

const FundDetailsBannerSkeleton = () => {
  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-8">
          <BaseSkeleton height="64px" />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12 col-md-8">
          <BaseSkeleton height="64px" />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12 col-md-4">
          <BaseSkeleton height="64px" />
        </div>

        <div className="col-12 col-md-8 mt-3 mt-md-0">
          <BaseSkeleton height="64px" />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <BaseSkeleton height="64px" />
        </div>
      </div>
    </div>
  );
};

export default FundDetailsBannerSkeleton;
